import type { MonospaceCollectionMeta } from '#layers/data-model';

export function isCollectionHidden(collection: { meta?: Pick<MonospaceCollectionMeta, 'isHidden'> | null } | null | undefined): boolean {
	return collection?.meta?.isHidden === true;
}
